module.exports = __webpack_public_path__ + "img/team_black.5020b961.jpg";